var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cart-header"},[_c('button',{staticClass:"btn btn-sm btn-icon",on:{"click":_vm.close}},[_c('span',{staticClass:"ti-arrow-left"}),_vm._v("\n    Назад\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }